module.exports = __webpack_public_path__ + "img/centrum-koffiekaart.3a0de369.png";